import React, { useEffect, useState } from "react";
import styles from "./SpecialistProfile.module.css";
import { MdDelete } from "react-icons/md";
// import doctorImg from "../../assets/images/specialist.jpg";
import { FaPencil } from "react-icons/fa6";
import { FaCheck, FaTimes } from "react-icons/fa";
import axios from "axios";
import Loading from "../Loading";
const SpecialistProfile = ({ data }) => {
  const [approvedSpecialists, setApprovedSpecialists] = useState(
    data?.approvedSpecialists
  );
  const [notApprovedSpecialists, setNotApprovedSpecialists] = useState(
    data?.notApprovedSpecialists
  );
  // useEffect(() => {
  //   if (data) {
  //     setApprovedSpecialists(data.approvedSpecialists || []);
  //     setNotApprovedSpecialists(data.notApprovedSpecialists || []);
  //   }
  // }, [data]);
  if (!data) {
    return (
      <span className={styles.loader}>
        <Loading />
      </span>
    );
  }

  const handleApproval = async (id, isAccepted) => {
    try {
      const response = await axios.post(
        `https://hidocdr.com/api/HidocDrConsultant/admin/approveOrRejectSpecialist?specialistId=${id}&isAccepted=${isAccepted}`
      );

      if (response.data.success === 1) {
        console.log(response.data, id);
        // Fetch updated data after approval/rejection
        const updatedData = {
          approvedSpecialists: approvedSpecialists.filter(
            (item) => item.id !== id
          ),
          notApprovedSpecialists: notApprovedSpecialists.filter(
            (item) => item.id !== id
          ),
        };

        setApprovedSpecialists(updatedData.approvedSpecialists);
        setNotApprovedSpecialists(updatedData.notApprovedSpecialists);
      }
      // } else {
      //   console.log("API call failed");
      // }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  console.log(approvedSpecialists);
  return (
    <>
      <div className={styles.top_container}>
        {data?.approvedSpecialists?.map((item) => (
          <div key={item.id} className={styles.parent_container}>
            <div className={styles.child_container}>
              <img
                src={item?.profileImage}
                alt="logo"
                className={styles.doctor_logo}
              />
              <div className={styles.name_speciality}>
                <p className={styles.user_name}>{item?.fullName}</p>
                <p className={styles.speciality} style={{ color: "#729cb2" }}>
                  {item?.speciality}
                </p>
              </div>
            </div>
            <div className={styles.edit_delete}>
              {/* <div className={styles.approv_reject}>
              <FaCheck
                className={styles.icon}
                color="green"
                title="approved"
                size={25}
              />
              <FaTimes
                className={styles.icon}
                color="red"
                title="reject"
                size={25}
              />
            </div> */}
              <div>
                <FaPencil
                  size={20}
                  color="white"
                  className={styles.icon}
                  title="Edit"
                />
              </div>
              <div>
                <MdDelete
                  size={20}
                  color="white"
                  className={styles.icon}
                  title="Delete"
                />
              </div>
            </div>
          </div>
        ))}
        <div>
          {data?.notApprovedSpecialists?.map((item) => (
            <div key={item.id} className={styles.parent_container}>
              <div className={styles.child_container}>
                <img
                  src={item?.profileImage}
                  alt="logo"
                  className={styles.doctor_logo}
                />
                <div className={styles.name_speciality}>
                  <p className={styles.user_name}>{item?.fullName}</p>
                  <p className={styles.speciality} style={{ color: "#729cb2" }}>
                    {item?.speciality}
                  </p>
                </div>
              </div>
              <div className={styles.edit_delete}>
                <div className={styles.approv_reject}>
                  <FaCheck
                    className={styles.icon}
                    color="green"
                    title="approved"
                    size={25}
                    onClick={() => handleApproval(item.id, 1)}
                  />
                  <FaTimes
                    className={styles.icon}
                    color="red"
                    title="reject"
                    size={25}
                    onClick={() => handleApproval(item.id, 0)}
                  />
                </div>
                <div>
                  <FaPencil
                    size={20}
                    color="white"
                    className={styles.icon}
                    title="Edit"
                  />
                </div>
                <div>
                  <MdDelete
                    size={20}
                    color="white"
                    className={styles.icon}
                    title="Delete"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SpecialistProfile;
